import styled from "styled-components";

export const AppContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100vh;
`